import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';
const ssoHost = publicConfig.external_address;

function _readMessages (path, accessToken, callback) {
  const request_params = {
    host: ssoHost,
    path,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + accessToken
    }
  };
  httpRequest(request_params, function (response) {
    callback(response);
  }, null);
}

function _createMessages (payload, token, callback) {
  const params = {
    host: ssoHost,
    method: 'POST',
    path: '/v1/message/send',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
  httpRequest(params, (res) => {
    callback(res);
  }, payload);
}

function _updateMessages (path, token, callback) {
  const params = {
    host: ssoHost,
    method: 'PUT',
    path: `/v1/message/update?${path}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
  httpRequest(params, (res) => {
    callback(res);
  });
}

const Messages = {

  /**
   * @function
   * @name readMessages
   * @param {String}   - Path String
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: (path, token, callback) => {
    const readMessages = _readMessages(path, token, callback);
    return readMessages;
  },

  /**
   * @function
   * @name getMessages
   * @param {Object}   - Payload
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */
  create: (payload, token, callback) => {
    const createMessages = _createMessages(payload, token, callback);
    return createMessages;
  },

  /**
   * @function
   * @name getMessages
   * @param {String}   - Path
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */
  update: (path, token, callback) => {
    const updateMessages = _updateMessages(path, token, callback);
    return updateMessages;
  }
};

export { Messages };
